import React from "react";
import { GlobalContext } from "../../../../../../utils/globalprovider";
class SubtitleNearMinimumGap extends React.Component {
    static contextType = GlobalContext;
    constructor(props) {
        super(props);

        this.state = {
            enabled: props.enabled ?? false,
            value: props.value ?? 0,
            ignoreSceneChanges: props.ignoreSceneChanges ?? false
        };
    }

    notifyChange = () => {
        if (this.props.onChange) {
            this.props.onChange({
                enabled: this.state.enabled,
                value: this.state.value,
                ignoreSceneChanges: this.state.ignoreSceneChanges
            });
        }
    }

    handleEnabled = (e) => {
        this.setState(
            { enabled: e.target.checked },
            this.notifyChange
        );
    }

    handleValue = (e) => {
        let value = parseInt(e.target.value);

        if (isNaN(value))
            value = 0;

        value = Math.max(0, Math.min(25, value));

        this.setState(
            { value },
            this.notifyChange
        );
    }

    handleIgnoreSceneChanges = (e) => {
        this.setState(
            { ignoreSceneChanges: e.target.checked },
            this.notifyChange
        );
    }

    render() {

        const styleContainer = {
            width: "98%",
            backgroundColor: "#000",
            color: "#FFF",
            fontSize: "12px",
            boxSizing: "border-box",
            padding: "10px",
            border: "1px solid #555",
            borderRadius: "6px",
            marginBottom: "8px",
            textAlign: "left",
        };

        const styleRow = {
            display: "flex",
            alignItems: "center",
            marginTop: "8px"
        };

        const styleLabel = {
            width: "70px",
            flexShrink: 0
        };

        const styleSpin = {
            width: "60px",
            backgroundColor: "#222",
            color: "#FFF",
            border: "1px solid #666",
            borderRadius: "4px",
            fontSize: "12px",
            padding: "2px 4px"
        };

        return (
            <div style={styleContainer}>

                <div style={{ fontWeight: "bold",textAlign: "center" }}>
                    {this.context.language=="fr"?"Sous-titre proche de l'intervalle minimum":"Subtitle close to the minimum interval"}
                </div>

                <div style={{ marginTop: "8px" }}>
                    <label>
                        <input
                            type="checkbox"
                            checked={this.state.enabled}
                            onChange={this.handleEnabled}
                            style={{ marginRight: "6px" }}
                        />
                        {this.context.language=="fr"?"Diminuer l'intervalle entre sous-titres si il est proche de l'intervalle minimum":"Reduce the interval between subtitles if it is close to the minimum interval"}
                    </label>
                </div>

                <div style={styleRow}>
                    <div style={styleLabel}>
                        {this.context.language=="fr"?"Valeur":"Value"}
                    </div>

                    <input
                        type="number"
                        min={0}
                        max={25}
                        value={this.state.value}
                        onChange={this.handleValue}
                        style={styleSpin}
                        disabled={!this.state.enabled}
                    />
                </div>

                <div style={{ marginTop: "8px" }}>
                    <label>
                        <input
                            type="checkbox"
                            checked={this.state.ignoreSceneChanges}
                            onChange={this.handleIgnoreSceneChanges}
                            style={{ marginRight: "6px" }}
                            disabled={!this.state.enabled}
                        />
                        {this.context.language=="fr"?"Ne pas tenir compte des changements de plan":"Disregard shots"}
                        
                    </label>
                </div>

            </div>
        );
    }
}

export default SubtitleNearMinimumGap;